export default __webpack_public_path__ + "bbc19ffad09547c1f0918dca428dca08.png";